import axiosHttp from "services/axiosHttp";
import { USER } from "constants/AuthConstant";
import PermissionManager from "utils/class/PermissionManager";

const { createSlice, createAsyncThunk } = require("@reduxjs/toolkit");

//action
export const fetchPaymentRequestInfo = createAsyncThunk("fetchPaymentRequestInfo", async (id) => {
	const user = PermissionManager.getItem(USER)?.user;
	const channel_id = user?.user_channel?.[0]?.channel_uuid;
	if (!channel_id) throw new Error("Channel ID not found");
	const response = await axiosHttp.get(`channel/${channel_id}/payment/request/${id}`);
	return response.data.data;
});

const PaymentRequestInfoSlice = createSlice({
	name: "PaymentRequestInfoSlice",
	initialState: {
		isLoading: false,
		data: null,
		error: null,
	},

	extraReducers: (builder) => {
		builder.addCase(fetchPaymentRequestInfo.pending, (state) => {
			state.isLoading = true;
		});

		builder.addCase(fetchPaymentRequestInfo.fulfilled, (state, action) => {
			state.isLoading = false;
			state.data = action.payload;
		});
		builder.addCase(fetchPaymentRequestInfo.rejected, (state, action) => {
			state.isLoading = false;
			state.error = action.payload;
		});
	},
});

export default PaymentRequestInfoSlice.reducer;
